import React from 'react';
import { makeStyles, MenuItem } from "../../../../index";
var useStyles = makeStyles(function (theme) { return ({
    root: {
        height: 40,
        padding: theme.spacing(1, 0),
    },
}); });
export var OrganizationMenuItem = React.memo(function (props) {
    var organization = props.organization, onClick = props.onClick;
    var classes = useStyles();
    return (React.createElement(MenuItem, { className: classes.root, onClick: function () { return onClick(organization); } }, organization.fullName));
});
